<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <comision-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ComisionCrud from "./ComisionCrud";
    export default {
        name: "Comision",
        components: {ComisionCrud}
    }
</script>

<style scoped>

</style>

